/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_FooterInputs */

const vi_trace_footer = /** @type {(inputs: Trace_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin truy xuất nguồn gốc sản phẩm nông nghiệp`)
};

/**

* @param {Trace_FooterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_footer = /** @type {((inputs?: Trace_FooterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_FooterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_footer(inputs)
});